import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import Icon from "@irati/ui/src/Icon"
import {greys} from "@irati/ui/src/global/colors"
import id from "@irati/utils/id"

import Row from "./Row"

const StyledRow = styled(Row)`
  margin-right: ${({theme}) => theme.spacing.oneAndHalf};
`

const StyledIcon = styled(Icon)`
  margin-right: 6px;
`

const HighlightRow = (props) => {
  const {icon, size, children} = props
  const idNamespace = id("highlight-row", props)
  return (
    <StyledRow id={idNamespace}>
      <StyledIcon id={id("icon", idNamespace)} size={size} icon={icon} color={greys.mediumDark} />
      {children}
    </StyledRow>
  )
}

HighlightRow.propTypes = {
  size: PropTypes.number.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default HighlightRow
